// extracted by mini-css-extract-plugin
export var actionSelect = "_ss-0";